<template>
  <div class="content">
    <div class="content__title content__title--party content__title--start">
      <router-link
        :to="{ name: 'primary' }"
        class="button button--light button--no-indent button--small"
      >
        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.70917 13.7082C7.61629 13.8013 7.50595 13.8752 7.38447 13.9256C7.263 13.976 7.13277 14.002 7.00125 14.002C6.86973 14.002 6.7395 13.976 6.61802 13.9256C6.49655 13.8752 6.38621 13.8013 6.29332 13.7082L0.293962 7.70884C0.200846 7.61595 0.126968 7.50562 0.0765611 7.38414C0.0261537 7.26266 0.000206594 7.13243 0.000206606 7.00091C0.000206617 6.86939 0.0261537 6.73916 0.0765611 6.61769C0.126969 6.49621 0.200846 6.38587 0.293962 6.29299L6.29333 0.293626C6.48108 0.105873 6.73573 0.00039471 7.00125 0.000394734C7.26677 0.000394757 7.52142 0.105873 7.70918 0.293626C7.89693 0.481379 8.00241 0.736028 8.00241 1.00155C8.00241 1.26707 7.89693 1.52172 7.70917 1.70948L2.41574 7.00091L7.70917 12.2923C7.80229 12.3852 7.87617 12.4956 7.92658 12.617C7.97698 12.7385 8.00293 12.8688 8.00293 13.0003C8.00293 13.1318 7.97698 13.262 7.92658 13.3835C7.87617 13.505 7.80229 13.6153 7.70917 13.7082Z" fill="#2B93E7"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M16 7.00108C16 7.26627 15.8947 7.5206 15.7071 7.70811C15.5196 7.89563 15.2653 8.00098 15.0001 8.00098L2.00149 8.00098C1.7363 8.00098 1.48197 7.89563 1.29445 7.70811C1.10694 7.5206 1.00159 7.26627 1.00159 7.00108C1.00159 6.73589 1.10694 6.48156 1.29445 6.29405C1.48197 6.10653 1.7363 6.00119 2.00149 6.00119L15.0001 6.00119C15.2653 6.00119 15.5196 6.10653 15.7071 6.29405C15.8947 6.48157 16 6.73589 16 7.00108Z" fill="#2B93E7"/>
        </svg>
      </router-link>
      <h1 class="title title--big title--theme">Статистика: Первичные группы</h1>
    </div>
    
    <!-- Кнопки экспорта -->
    <div class="export-buttons">
      <button @click="exportToExcel" class="button button--primary button--small">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style="vertical-align: middle; margin-right: 5px;">
          <path d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Excel
      </button>
      <button @click="exportToWord" class="button button--secondary button--small" style="margin-left: 10px;">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style="vertical-align: middle; margin-right: 5px;">
          <path d="M14.5 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V7.5L14.5 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Word
      </button>
    </div>

    <v-client-table
      :data="tableDataWithTotals"
      :columns="table.columns"
      :options="table.options"
      ref="userListTable"
      class="table-default"
    >
      <div slot="organization_name" slot-scope="props" class="table-default__left">
        {{ getOrganizationName(props.row) }}
      </div>
      
      <!-- Кастомный рендеринг для итоговых строк -->
      <div slot="accepted" slot-scope="props" :class="{'table-total': props.row.isTotalRow}">
        {{ props.row.accepted }}
      </div>
      <div slot="draft" slot-scope="props" :class="{'table-total': props.row.isTotalRow}">
        {{ props.row.draft }}
      </div>
      <div slot="rejected" slot-scope="props" :class="{'table-total': props.row.isTotalRow}">
        {{ props.row.rejected }}
      </div>
      <div slot="review" slot-scope="props" :class="{'table-total': props.row.isTotalRow}">
        {{ props.row.review }}
      </div>
      <div slot="count" slot-scope="props" :class="{'table-total': props.row.isTotalRow}">
        {{ props.row.count }}
      </div>
    </v-client-table>
  </div>
</template>

<script>
export default {
  name: 'StatInformationPrimary',
  data() {
    return {
      // Маппинг для названий организаций: { [id]: 'Название' }
      organizationMap: {},
      // Обратный маппинг: { 'Название региона': 'Название организации' }
      regionToOrganizationMap: {},
      table: {
        users: [],
        columns: ['organization_name', 'accepted', 'draft', 'rejected', 'review', 'count'],
        options: {
          headings: {
            organization_name: 'Организация',
            accepted: 'Приняты',
            draft: 'Черновики',
            rejected: 'Отклонены',
            review: 'На рассмотрении',
            count: 'Количество',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 150,
          texts: {
            filter: '',
            filterPlaceholder: 'Поиск по таблице',
            noResults: 'Нет подходящих записей',
            filterBy: '',
            loading: 'Загрузка',
            count: '',
            limit: 'Количество записей на странице:',
            page: 'Страница:'
          },
          rowClassCallback: row => {
            if (row.isTotalRow) {
              return 'table-default__row table-total-row'
            }
            return `table-default__row table-default__row--${row.status || 'default'}`
          },
        },
      },
    }
  },
  computed: {
    // Добавляем итоговые строки к данным таблицы
    tableDataWithTotals() {
      if (!this.table.users || this.table.users.length === 0) {
        return []
      }
      
      const totals = this.calculateTotals()
      return [...this.table.users, ...totals]
    }
  },
  mounted() {
    this.loadOrganizations()
    this.fetchItems()
  },
  methods: {
    // Загрузка списка организаций для маппинга ID -> название
    async loadOrganizations() {
      try {
        const response = await this.$store.dispatch('regOrg/GET_QUERY')
        console.log('Ответ от regOrg/GET_QUERY:', response)
        
        let orgData = []
        
        // Определяем формат ответа
        if (response && response.data && Array.isArray(response.data)) {
          // Формат: { data: [...] }
          orgData = response.data
        } else if (response && Array.isArray(response)) {
          // Формат: [...]
          orgData = response
        } else if (response && response.results && Array.isArray(response.results)) {
          // Формат: { results: [...] }
          orgData = response.results
        }
        
        console.log('Данные организаций:', orgData)
        
        if (orgData.length > 0) {
          // Создаем маппинг: { [id]: 'Название организации' }
          this.organizationMap = orgData.reduce((map, org) => {
            map[org.id] = org.name
            return map
          }, {})
          console.log('Загружен маппинг организаций:', this.organizationMap)
          
          // Создаем обратный маппинг: { 'Название региона': 'Название организации' }
          this.regionToOrganizationMap = {}
          orgData.forEach(org => {
            // Если у организации есть регион - используем его как ключ
            if (org.region_name) {
              this.regionToOrganizationMap[org.region_name] = org.name
            }
            // Или используем ID региона, если есть
            if (org.region_id) {
              // Найдем название региона по ID из маппинга
              const regionName = this.organizationMap[org.region_id]
              if (regionName) {
                this.regionToOrganizationMap[regionName] = org.name
              }
            }
          })
          console.log('Обратный маппинг регион->организация:', this.regionToOrganizationMap)
        } else {
          console.warn('Получен пустой список организаций')
        }
      } catch (error) {
        console.error('Ошибка загрузки списка организаций:', error)
        this.$notify({
          type: 'warn',
          title: 'Внимание!',
          text: 'Не удалось загрузить список организаций. Названия могут отображаться некорректно.'
        })
      }
    },
    
    // Получение названия организации по данным строки
    getOrganizationName(row) {
      console.log('Строка данных:', row)
      
      // 1. Если есть прямое название организации - используем его
      if (row.organization_name) {
        console.log('Используем organization_name:', row.organization_name)
        return row.organization_name
      }
      
      // 2. Если есть регион ID - ищем в маппинге
      const orgId = row.region_id || row.region_org_id || row.organization_id
      if (orgId || orgId === 0) {
        const orgName = this.organizationMap[orgId]
        if (orgName) {
          console.log(`Нашли название по ID ${orgId}:`, orgName)
          return orgName
        }
        console.log(`ID ${orgId} не найден в маппинге`)
        return `ID: ${orgId}`
      }
      
      // 3. Если есть название региона - ищем в обратном маппинге
      if (row.region_name) {
        const orgName = this.regionToOrganizationMap[row.region_name]
        if (orgName) {
          console.log(`Нашли организацию по региону "${row.region_name}":`, orgName)
          return orgName
        }
        console.log(`Регион "${row.region_name}" не найден в обратном маппинге, возвращаем регион`)
        // Если не нашли - возвращаем название региона (фолбэк)
        return row.region_name
      }
      
      // 4. Если есть регион название - используем его (альтернативное поле)
      if (row.region) {
        return row.region
      }
      
      // 5. Если есть регион название - используем его (альтернативное поле)
      if (row.name) {
        return row.name
      }
      
      // 6. Если есть регион название - используем его (альтернативное поле)
      if (row.title) {
        return row.title
      }
      
      // 7. Если есть регион название - используем его (альтернативное поле)
      if (row.org_name) {
        return row.org_name
      }
      
      return 'Без названия'
    },
    
    fetchItems() {
      this.$store.dispatch('primary/GET_STAT')
        .then(response => {
          console.log('Ответ от primary/GET_STAT:', response)
          
          let data = []
          
          // Определяем формат ответа
          if (response && response.data && Array.isArray(response.data)) {
            // Формат: { data: [...] }
            data = response.data
          } else if (response && Array.isArray(response)) {
            // Формат: [...]
            data = response
          } else if (response && response.results && Array.isArray(response.results)) {
            // Формат: { results: [...] }
            data = response.results
          }
          
          console.log('Данные статистики первичных групп:', data)
          console.log('Первая строка:', data[0])
          this.table.users = data
        })
        .catch(error => {
          this.$notify({
            type: 'warn',
            title: 'Внимание!',
            text: `Ошибка загрузки данных: ${ error.message }`
          })
          console.error('Ошибка загрузки статистики первичных групп:', error)
        })
    },
    
    // Расчет итоговых значений для РО и ОП
    calculateTotals() {
      let roTotal = {
        organization_name: 'Итого по РО:',
        accepted: 0,
        draft: 0,
        rejected: 0,
        review: 0,
        count: 0,
        isTotalRow: true
      }
      
      let opTotal = {
        organization_name: 'Итого по ОП:',
        accepted: 0,
        draft: 0,
        rejected: 0,
        review: 0,
        count: 0,
        isTotalRow: true
      }
      
      let grandTotal = {
        organization_name: 'Общий итог:',
        accepted: 0,
        draft: 0,
        rejected: 0,
        review: 0,
        count: 0,
        isTotalRow: true
      }
      
      this.table.users.forEach(row => {
        // Определяем тип организации по названию
        // Используем \b для поиска отдельных слов "оп" или "представительство"
        const orgName = this.getOrganizationName(row)
        const isOP = /\bоп\b|\bпредставительство\b/i.test(orgName)
        
        const values = {
          accepted: parseInt(row.accepted) || 0,
          draft: parseInt(row.draft) || 0,
          rejected: parseInt(row.rejected) || 0,
          review: parseInt(row.review) || 0,
          count: parseInt(row.count) || 0
        }
        
        if (isOP) {
          // ОП
          opTotal.accepted += values.accepted
          opTotal.draft += values.draft
          opTotal.rejected += values.rejected
          opTotal.review += values.review
          opTotal.count += values.count
        } else {
          // РО
          roTotal.accepted += values.accepted
          roTotal.draft += values.draft
          roTotal.rejected += values.rejected
          roTotal.review += values.review
          roTotal.count += values.count
        }
        
        // Общий итог
        grandTotal.accepted += values.accepted
        grandTotal.draft += values.draft
        grandTotal.rejected += values.rejected
        grandTotal.review += values.review
        grandTotal.count += values.count
      })
      
      return [roTotal, opTotal, grandTotal]
    },
    
    // Экспорт в Excel (CSV формат с точкой с запятой)
    exportToExcel() {
      if (!this.table.users || this.table.users.length === 0) {
        this.$notify({
          type: 'warn',
          title: 'Внимание!',
          text: 'Нет данных для экспорта'
        })
        return
      }

      try {
        // Заголовки
        const headers = this.table.columns.map(col => this.table.options.headings[col] || col)
        
        // Данные
        const dataToExport = this.table.users
        const totals = this.calculateTotals()
        
        // Данные
        const data = dataToExport.map(row => {
          return this.table.columns.map(col => {
            let value
            if (col === 'organization_name') {
              // Специальная обработка для названия организации через маппинг
              value = this.getOrganizationName(row)
            } else {
              value = row[col]
            }
            
            if (value === null || value === undefined) return ''
            const strValue = String(value)
            if (strValue.includes(';') || strValue.includes('"') || strValue.includes('\n')) {
              return `"${strValue.replace(/"/g, '""')}"`
            }
            return strValue
          })
        })
        
        // Добавляем итоговые строки
        totals.forEach(totalRow => {
          const totalsRow = this.table.columns.map(col => {
            const value = totalRow[col]
            if (value === null || value === undefined) return ''
            const strValue = String(value)
            if (strValue.includes(';') || strValue.includes('"') || strValue.includes('\n')) {
              return `"${strValue.replace(/"/g, '""')}"`
            }
            return strValue
          })
          data.push(totalsRow)
        })
        
        // Добавляем заголовки
        data.unshift(headers)
        
        // Используем точку с запятой как разделитель
        const csvContent = data.map(row => row.join(';')).join('\n')
        
        // Создаем Blob и скачиваем файл
        const blob = new Blob(['\ufeff' + csvContent], { 
          type: 'text/csv;charset=utf-8;'
        })
        
        const link = document.createElement('a')
        const url = URL.createObjectURL(blob)
        const date = new Date().toLocaleDateString('ru-RU').replace(/\./g, '-')
        const filename = `Статистика_Первичные_группы_${date}.csv`
        link.setAttribute('href', url)
        link.setAttribute('download', filename)
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        
        this.$notify({
          type: 'success',
          title: 'Успешно!',
          text: 'Данные экспортированы в Excel'
        })
      } catch (error) {
        this.$notify({
          type: 'error',
          title: 'Ошибка!',
          text: `Не удалось экспортировать данные: ${error.message}`
        })
        console.error('Ошибка экспорта в Excel:', error)
      }
    },
    
    // Экспорт в Word (HTML формат)
    exportToWord() {
      if (!this.table.users || this.table.users.length === 0) {
        this.$notify({
          type: 'warn',
          title: 'Внимание!',
          text: 'Нет данных для экспорта'
        })
        return
      }

      try {
        const date = new Date()
        const dateStr = date.toLocaleDateString('ru-RU')
        const timeStr = date.toLocaleTimeString('ru-RU')
        
        // Данные
        const dataToExport = this.table.users
        const totals = this.calculateTotals()
        
        // Создаем заголовок документа
        const title = 'Статистика: Первичные группы'
        
        // Создаем HTML для документа Word
        let html = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>${title}</title>
  <style>
    body {
      font-family: Times New Roman, serif;
      font-size: 12pt;
      line-height: 1.5;
    }
    h1 {
      text-align: center;
      margin-bottom: 20px;
      font-size: 16pt;
      font-weight: bold;
    }
    .info {
      margin-bottom: 20px;
      text-align: center;
      font-size: 10pt;
      color: #666;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 20px;
    }
    th {
      background-color: #f0f0f0;
      border: 1px solid #000;
      padding: 8px;
      text-align: left;
      font-weight: bold;
    }
    td {
      border: 1px solid #000;
      padding: 8px;
      text-align: left;
    }
    tr:nth-child(even) {
      background-color: #f9f9f9;
    }
    .total-row {
      font-weight: bold;
      background-color: #e8e8e8 !important;
    }
    .footer {
      margin-top: 30px;
      text-align: center;
      font-size: 10pt;
      color: #666;
    }
  </style>
</head>
<body>
  <h1>${title}</h1>
  <div class="info">
    <div>Дата формирования: ${dateStr}</div>
    <div>Время: ${timeStr}</div>
  </div>
  <table>
    <thead>
      <tr>
        ${this.table.columns.map(col => `<th>${this.table.options.headings[col] || col}</th>`).join('')}
      </tr>
    </thead>
    <tbody>
`

        // Добавляем строки данных
        dataToExport.forEach(row => {
          html += '      <tr>\n'
          this.table.columns.forEach(col => {
            let value
            if (col === 'organization_name') {
              // Специальная обработка для названия организации через маппинг
              value = this.getOrganizationName(row)
            } else {
              value = row[col]
            }
            const cellValue = value === null || value === undefined ? '' : value
            html += `        <td>${cellValue}</td>\n`
          })
          html += '      </tr>\n'
        })

        // Добавляем итоговые строки
        totals.forEach(totalRow => {
          html += '      <tr class="total-row">\n'
          this.table.columns.forEach(col => {
            const value = totalRow[col]
            const cellValue = value === null || value === undefined ? '' : value
            html += `        <td>${cellValue}</td>\n`
          })
          html += '      </tr>\n'
        })

        html += `
    </tbody>
  </table>
  <div class="footer">
    <p>Количество записей: ${dataToExport.length}</p>
    <p>Итого по всем столбцам указано в последних строках таблицы</p>
  </div>
</body>
</html>
`

        // Создаем Blob и скачиваем файл
        const blob = new Blob([html], { 
          type: 'application/msword;charset=utf-8'
        })
        
        const link = document.createElement('a')
        const url = URL.createObjectURL(blob)
        const fileNameDate = date.toLocaleDateString('ru-RU').replace(/\./g, '-')
        const filename = `Статистика_Первичные_группы_${fileNameDate}.doc`
        link.setAttribute('href', url)
        link.setAttribute('download', filename)
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        
        this.$notify({
          type: 'success',
          title: 'Успешно!',
          text: 'Данные экспортированы в Word'
        })
      } catch (error) {
        this.$notify({
          type: 'error',
          title: 'Ошибка!',
          text: `Не удалось экспортировать данные: ${error.message}`
        })
        console.error('Ошибка экспорта в Word:', error)
      }
    },
  }
}
</script>

<style scoped>
.export-buttons {
  margin-bottom: 20px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
  display: inline-flex;
  align-items: center;
}

.button--primary {
  background-color: #2B93E7;
  color: white;
}

.button--primary:hover {
  background-color: #1a7bc9;
}

.button--secondary {
  background-color: #6c757d;
  color: white;
}

.button--secondary:hover {
  background-color: #5a6268;
}

.button--small {
  padding: 6px 12px;
  font-size: 13px;
}

.table-total {
  font-weight: bold;
  color: #000 !important;
}

.table-total-row {
  background-color: #f8f9fa !important;
  font-weight: bold;
}

.table-total-row td {
  font-weight: bold !important;
}
</style>